
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projectos-financiados",
      function () {
        return require("private-next-pages/projectos-financiados/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projectos-financiados"])
      });
    }
  